import React from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import classnames from 'classnames';
import moment from 'moment/moment';
import {useCustomerDetailsUIContext} from '../CustomerDetailsUIContext';
import Empty from '../../../_common/components/Empty';
import ButtonUploadFile from '../../../_common/components/ButtonUploadFile';
import Unit from '../../../_common/components/Unit';
import Thumbnail from '../../../_common/components/Thumbnail';
import FileIcon from '../../../_common/components/FileIcon';
import PopupDeleteFile from '../../../_common/components/PopupDeleteFile/PopupDeleteFile';
import ButtonAction from '../../../_common/components/ButtonAction';
import Spinner from '../../../_common/components/Spinner';
import ButtonDD from "../../../_common/components/ButtonDD";
import styles from './styles.module.scss';
import themeStyles from "../../../_common/styles/theme.module.scss";
import {useGlobalContext} from "../../../_common/contexts/GlobalContext";

const TabCustomerFiles = () => {
  const {formatMessage} = useIntl();
  const {fileList, handleFileUpload, handleFileDownload, handleFileDelete, loading} = useCustomerDetailsUIContext();
  const prefix = 'tab-order-documents-column';
  const {isGlassTheme} = useGlobalContext();

  return loading ? <Spinner customContainerStyles={'d-flex justify-content-center'}/> : (
    <div className={styles.tabCustomerFilesContainer}>
      <ButtonUploadFile
        showIcon={true}
        label={<FormattedMessage id="upload-file" defaultMessage="Upload file"/>}
        onChange={(e) => handleFileUpload(e)}
        customContainerStyles={styles.buttonUpload}
      />
      {fileList.length > 0
        ?
        (
          <Unit
            icon={'/media/common/Folder_green.svg'}
            text={formatMessage({id: 'header-files', defaultMessage: 'Files'})}
          >
            <div className={classnames(styles.header,
              isGlassTheme ? themeStyles.filter : themeStyles.noFilter,
              isGlassTheme ? themeStyles.primaryBackground : themeStyles.usualBackground
            )}>
              <div className={styles.headerCell}/>
              <div className={styles.headerCell}>
                {formatMessage({id: `${prefix}-uploadDate`, defaultMessage: 'Upload date'})}
              </div>
              <div className={styles.headerCell}>
                {formatMessage({id: `${prefix}-fileName`, defaultMessage: 'Name'})}
              </div>
              <div className={styles.headerCell}>
                {formatMessage({id: `${prefix}-fileType`, defaultMessage: 'Type'})}
              </div>
              <div className={styles.headerCell}/>
            </div>
            <div className={styles.filesContainer}>
              {fileList.map((item, ind) => (
                <div key={ind} className={styles.row}>
                  <Thumbnail fileExtension={item.fileExtension} uri={item.thumbnail} fileToSave={null}/>
                  <div
                    className={classnames(styles.cell, 'badge', 'text-dark-75 font-weight-bolder font-size-lg text-nowrap')}>
                    <div className={styles.dateCell}>
                      {item.uploadTime ? moment(item.uploadTime).format('DD-MM-YYYY') : ''}
                    </div>
                  </div>
                  <div className={classnames(styles.cell, 'd-flex align-items-center')}>
                    <div className="ml-2 text-truncate" title={item.fileName}>{item.fileName}</div>
                  </div>
                  <div className={styles.cell}>
                    <FileIcon fileExtension={item.fileExtension} size={'sm'}/>
                  </div>
                  <div className={styles.lastCell}>
                    <ButtonDD
                      items={[{
                        itemContent: (
                          <div className={'d-flex align-items-center justify-content-between'}>
                            <PopupDeleteFile
                              fileName={item.fileName}
                              onDelete={() => {
                                handleFileDelete(item.fileName, item.fileID);
                              }}
                            />
                            <ButtonAction
                              iconButtonType={'secondary'}
                              variant={'icon'}
                              label={
                                <img
                                  src={'../../../media/common/Download_secondary.svg'}
                                  alt="download" className="w-20px h-20px"
                                />
                              }
                              onClick={() => handleFileDownload(item.fileName)}
                              disabled={false}
                              customClassnames={'ml-4'}
                            />
                          </div>
                        )
                      }
                      ]}
                    />
                  </div>
                </div>
              ))}
            </div>
          </Unit>
        )
        : <Empty customContainerClassname={styles.emptyContainer}/>
      }
    </div>
  );
};

export default TabCustomerFiles;
